import {
    ROOT,
    CHAIN_GET_LIST_SERVICE,
    CHAIN_SORT_LIST_SERVICE,
    CHAIN_UPDATE_STATUS_SERVICE,
    CHAIN_DELETE_SERVICE,
    CHAIN_DETAIL_SERVICE,
    UPLOAD_IMAGE_RESOURCE,
    DELETE_IMAGE_RESOURCE,
    CHAIN_UPDATE_SERVICE,
    CHAIN_CREATE_SERVICE,
    CHAIN_CHECK_SERVICE_CODE,
    CHAIN_CHECK_SPECIAL_DAYS_PRICE,
    CHAIN_DELETE_SERVICE_LIST,
    CHAIN_UPDATE_STATUS_SERVICE_ALL,
    CHAIN_GET_ALL_UNIT
  } from "@/_helpers/constant.js";
  import { requestOptions, handleResponse } from "@/_helpers";
  
  //#region list of rooms
  function get() {
    return fetch(ROOT + CHAIN_GET_LIST_SERVICE, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function sortService(body) {
    return fetch(ROOT + CHAIN_SORT_LIST_SERVICE, requestOptions.post(body))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function updateStatus(id) {
    return fetch(ROOT + CHAIN_UPDATE_STATUS_SERVICE + `/${id}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function updateStatusAll(body) {
    return fetch(ROOT + CHAIN_UPDATE_STATUS_SERVICE_ALL, requestOptions.post(body))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function deleteService(id) {
    return fetch(ROOT + CHAIN_DELETE_SERVICE + `/${id}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  function deleteServiceList(body) {
    return fetch(ROOT + CHAIN_DELETE_SERVICE_LIST, requestOptions.post(body))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function getDetailService(id) {
    return fetch(ROOT + CHAIN_DETAIL_SERVICE + `/${id}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function uploadImage(data) {
    let currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    let authHeader = currentUser.token ? { Authorization: "Token " + currentUser.token } : {};
    return fetch(ROOT + UPLOAD_IMAGE_RESOURCE, {
      method: "POST",
      body: data,
      headers: {
        Authorization: authHeader.Authorization
      }
    })
      .then(handleResponse)
      .then(data => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        return data;
      });
  }
  
  function removeImage(id) {
    return fetch(ROOT + DELETE_IMAGE_RESOURCE + `/${id}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        return data;
      });
  }
  
  function updateService(body) {
    return fetch(ROOT + CHAIN_UPDATE_SERVICE, requestOptions.post(body))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function createService(body) {
    return fetch(ROOT + CHAIN_CREATE_SERVICE, requestOptions.post(body))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function checkServiceCode(code) {
    return fetch(ROOT + CHAIN_CHECK_SERVICE_CODE + `/${code}`, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function checkSpecialDaysPrice(body) {
    return fetch(ROOT + CHAIN_CHECK_SPECIAL_DAYS_PRICE, requestOptions.post(body))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function getUnit() {
    return fetch(ROOT + CHAIN_GET_ALL_UNIT, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  //#endregion
  export const ChainService = {
    get,
    sortService,
    updateStatus,
    deleteService,
    getDetailService,
    uploadImage,
    removeImage,
    updateService,
    createService,
    checkServiceCode,
    checkSpecialDaysPrice,
    deleteServiceList,
    updateStatusAll,
    getUnit
  };
  